// components/StoryContent.jsx
import React from "react";
import truncate from "truncate-html";

const processContent = (htmlString) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");

  // ✅ Remove unwanted tags but keep their content
  doc.querySelectorAll("span").forEach((el) => {
    el.replaceWith(...el.childNodes);
  });

  const contentBlocks = [];

  // ✅ Loop through ALL top-level nodes (not just <p>)
  doc.body.childNodes.forEach((node) => {
    // Paragraphs
    if (node.nodeName === "P") {
      const text = node.innerHTML.trim();
      if (text && text !== "&nbsp;") {
        contentBlocks.push(`<p class="ql-align-justify">${text}</p>`);
      }
    }

    // Lists (UL / OL)
    if (node.nodeName === "UL" || node.nodeName === "OL") {
      contentBlocks.push(node.outerHTML);
    }

    // Optional: handle headings if they exist
    if (
      node.nodeName === "H1" ||
      node.nodeName === "H2" ||
      node.nodeName === "H3"
    ) {
      contentBlocks.push(
        `<${node.nodeName}>${node.innerHTML}</${node.nodeName}>`,
      );
    }
  });

  return {
    title: contentBlocks[0] || "",
    body: contentBlocks.slice(1),
  };
};

const stripHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return (doc.body.textContent || "").replace(/\u00A0/g, " ").trim();
};

const HTMLDisplay = ({ html, textNo, type, textSize = "1rem" }) => {
  const { title, body } = processContent(html);

  const TruncateHtml = (htmlString, length) => {
    return truncate(htmlString, length, { byWords: true });
  };

  // ✅ Convert body array into proper HTML
  const bodyHtml = body
    .map((para) => `<p className="ql-align-justify">${para}</p>`)
    .join("");

  const titles = stripHtml(title);
  const titleHtml = `<p className="ql-align-justify text-capitalize"><strong>${titles}</strong></p>`;

  // ✅ Choose what to display
  const finalHtml = type === "body" ? bodyHtml : titleHtml;

  // ✅ Only truncate AFTER it's valid HTML
  const shortHtml = TruncateHtml(finalHtml, textNo);

  return (
    <div
      className="story-content"
      dangerouslySetInnerHTML={{ __html: shortHtml }}
      style={{ fontSize: textSize }}
    />
  );
};

export default HTMLDisplay;
